import { HOME } from "@/constants/testIds";

const WORDS = ["Short Videos", "Private Chat", "Stories", "Privacy First", "Made in India", "Fast & Secure"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section id="stories" data-testid={HOME.marquee} className="relative overflow-hidden border-y border-white/10 py-14">
      <div className="flex w-max animate-marquee items-center gap-16 whitespace-nowrap will-change-transform">
        {row.map((w, i) => (
          <div key={i} className="flex items-center gap-16">
            <span className="text-outline font-display text-6xl font-semibold tracking-tight sm:text-7xl">
              {w}
            </span>
            <span className="h-3 w-3 rounded-full bg-indril-saffron" />
          </div>
        ))}
      </div>
    </section>
  );
};
